module.exports = __webpack_public_path__ + "img/137.8673ceb5.jpg";